export default "__VITE_ASSET__BHS_CTuo__"